'use strict';

var DatSpec = require('lib/DatSpec.js').DatSpec;
var LiteDatamapOpts = require('./LiteDatamapOpts.js').LiteDatamapOpts;
var colorbrewer = require('lib/colorbrewer.js').colorbrewer;

var setbool = DatSpec.setbool, setstr = DatSpec.setstr, setopts = DatSpec.setopts;
var setcolor = DatSpec.setcolor, setsubfolder = DatSpec.setsubfolder;
var setfolder = DatSpec.setfolder, setnum = DatSpec.setnum, setaction = DatSpec.setaction;
var addLiveUpdate = DatSpec.addLiveUpdate;

/*
 * btnId and sliderId need not be "id"s. "cats" is an array of
 * category elements over which the slider animates.
 */
function MySlider(btnId, sliderId, cats) {
    var self = this;

    this.setAnimator = function(animateFn) { self.animateFn = animateFn; };

    var legends = {}; cats.forEach((name, ni) => legends[ni + 1] = name);

    var data = d3.range(1, cats.length + 1);

    var btn = d3.select(btnId);

    var sliderEl = d3.select(sliderId);
    var vpadding = 20;
    var realHt = sliderEl.node().getBoundingClientRect().height - 2*vpadding;

    this.slider = d3.sliderRight()
	.min(1)
	.max(cats.length)
	.step(1)
	.tickFormat(function(a) {
	    return legends[a];
	})
	.height(realHt)
	.on('onchange', val => {
	    if ( self.animateFn ) self.animateFn();
	});

    var group = d3.select(sliderId)
	.append("g")
	.attr("transform", 'translate(20,'+vpadding+')')
	.call(this.slider);

    function Iter(arr) {
	var self = this;
	this.index = 0;
	this.nrevs = 0;
	this.arr = arr;
	this.next = function() {
            var value = self.arr[self.index];
            self.index++;
            if ( self.index == self.arr.length ) {
		self.nrevs++;
		self.index = 0;
            }
            return value;
	};
	this.revs = function() { return nrevs; }
	this.curr = function() { return arr[index]; }
    }

    var iter = new Iter(data);

    this.playFn = function() {
	self.slider.value(iter.next());
	if ( self.animateFn ) self.animateFn();
    };

    this.interval = 1000;

    btn.on('click', function() {
	var btn = d3.select(btnId);
	var state = btn.attr('data-state');
	if ( state === 'playing' ) {
	    if ( self.intId != 0 ) clearInterval(self.intId);
	    self.intId = 0;
	    btn.attr('data-state', 'pause');
	    btn.html('<i class="fa fa-play"></i>');
	} else {
	    self.intId = setInterval(self.playFn, self.interval);
	    btn.attr('data-state', 'playing');
	    btn.html('<i class="fa fa-pause"></i>');
	}
    });

    this.value = function() { return legends[self.slider.value()]; };

    return this;
}

function LiteDatamap(aggs, settings)
{
    var self = this;
    self.$aggs = aggs;		// data set
    console.log('aggs = %O', aggs);
    self.$settings = settings;	// options passed in at constuction time.
    self.$options = {};
    if ( 'options' in settings ) $.extend(true, self.$options, settings.options);
    self.$scope = 'world';
    self.$chartEl = settings && 'chartEl' in settings ? settings.chartEl : '#mover';
    self.renderChart();
}

LiteDatamap.prototype = Object.create(Object.prototype);

LiteDatamap.prototype.clearElement = function()
{
    $(this.$chartEl).find('svg,.chart,.opt-bar,.error').remove();
}

LiteDatamap.prototype.updateSpecs = function(opts)
{
    var self = this;

    opts.mergeSpecs({
	'0/Apply Changes': setaction(function() {
	    var options = opts.getValue();
	    var converted = opts.convert(options);
	    console.log('options = %O', converted);
	    self.$options = converted;
	    self.applyOptions(converted);
	}),
    });
}

/* NOTUSED */
LiteDatamap.prototype.setupDat = function()
{
    var self = this;
    dat.GUI.TEXT_OPEN = '<span class="navbar-toggler-icon"></span>';
    dat.GUI.TEXT_CLOSED = '<div style="background-color: black; color: white; text-align: center">Close Panel</div>';
    var gui = new dat.GUI({name: 'LiteDatamap', closeOnTop: false, autoPlace: false}); gui.close();
    $(self.$chartEl).find('.opt-bar').append(gui.domElement);
    var opts = new LiteDatamapOpts(gui);
    self.updateSpecs(opts);
    self.$gui = gui; self.$opts = opts; self.$gui.$owner = self;
    $('.dg.main .close-button.close-bottom')
	.css({ 'background': 'transparent', 'text-align': 'left', 'height': '100%' });
    return opts;
}

LiteDatamap.prototype.setupChartElement = function(needPlayer)
{
    var self = this;
    var right = parseInt($(self.$chartEl).find('.ui-resizable-e').css('width')) || 7;
    var top = parseInt($(self.$chartEl).find('.ui-resizable-n').css('height')) || 7;
    var ht = parseInt($(self.$chartEl).find('.ui-widget-header').css('height')) || 20;
    $(self.$chartEl)
	.append('<div style="position: absolute; width: 244px; height: '+ht+'px;' +
		' right:'+right+'px; top:'+top+'px; z-index: 10000;" class="opt-bar navbar-light"></div>');
    var htmlStr = ''
    if ( needPlayer ) {
	htmlStr += ('<div class="d3 litedatamap" style="display:grid;grid-template-columns:75px repeat(8,1fr);grid-template-rows:repeat(8,1fr) 50px;width:100%;height:100%;">' +
		    '<div class="playbtn" style="position:relative;grid-row-start:1;grid-column-start:1;grid-row-end:2;grid-column-end:2;"><button style="position:absolute;bottom:0;" class="btn btn-success" data-state="pause"><i class="fa fa-play"></i></button></div>' +
		    '<div class="slider" style="grid-row-start:2;grid-column-start:1;grid-row-end:10;grid-column-end:2;"><svg style="width:100%;height:100%;"></svg></div>' +
		    '<div class="title-block" style="grid-row-start:1;grid-row-end:2;grid-column-start:2;grid-column-end:10;"><h1></h1><h2></h2></div>' +
		    '<div class="chart" style="grid-row-start:2;grid-column-start:2;grid-row-end:9;grid-column-end:10;"></div>' +
		    '<div class="legend" style="grid-row-start:9;grid-row-end:10;grid-column-start:2;grid-column-end:10;"></div>' +
		    '</div>');
    } else {
	htmlStr += ('<div class="d3 litedatamap" style="display:grid;grid-template-columns:repeat(9,1fr);grid-template-rows:repeat(8,1fr) 3em;width:100%;height:100%;">' +
		    '<div class="title-block" style="grid-row-start:1;grid-row-end:2;grid-column-start:1;grid-column-end:10;"><h1></h1><h2></h2></div>' +
		    '<div class="chart" style="grid-row-start:2;grid-column-start:1;grid-row-end:9;grid-column-end:10;"></div>' +
		    '<div class="legend" style="grid-row-start:9;grid-row-end:10;grid-column-start:2;grid-column-end:10;"></div>' +
		    '</div>');
    }
    $(self.$chartEl).append(htmlStr);
}

LiteDatamap.prototype.setupTitle = function()
{
    var self = this;
    $(self.$chartEl).find('.title-block h1')
	.attr('style', _.get(self.$options, 'title.titleStyle', ''))
	.html(_.get(self.$options, 'title.text', ''));
    $(self.$chartEl).find('.title-block h2')
	.attr('style', _.get(self.$options, 'title.subtitleStyle', ''))
	.html(_.get(self.$options, 'title.subtext', ''));
}

LiteDatamap.prototype.setupColors = function(legend)
{
    var self = this;
    var scale = _.get(self.$options, 'series.colorMap.scaleType', 'd3-ordinal');
    var cfn;
    if ( scale === 'd3-sequential' ) {
	var interp = _.get(self.$options, 'series.colorMap.d3-interpolator', 'Turbo');
	var ip = d3['interpolate' + interp];
	if ( ! ip ) {
	    ip = d3.interpolateTurbo;
	    console.warn('sequential color scheme "%O" not available. using "Turbo".', interp);
	}
	cfn = d3.scaleSequential(ip).domain(legend.sizeRange);
    } else if ( scale == 'd3-ordinal' ) {
	var schemeName = _.get(self.$options, 'series.colorMap.categorical', 'category10');
	var ncolors = _.get(self.$options, 'series.colorMap.numColors', 5);
	var scheme = d3['scheme' + schemeName];
	if ( ! scheme ) {
	    scheme = d3.schemeCategory10;
	    console.warn('categorical color scheme "%O" not available. using "Category10"', schemeName);
	}
	cfn = d3.scaleOrdinal(scheme).domain(legend.sizeRange);
    } else if ( scale == 'colorbrewer' ) {
	var ncolors = _.get(self.$options, 'series.colorMap.numColors', 5);
	var scheme = _.get(self.$options, 'series.colorMap.colorbrewer', 'OrRd');
	var ip;
	if ( scheme == 'auto' ) {
	    let ex = self.$extent;
	    if ( ex[0] < 0 && ex[1] > 0 ) {
		// need diverging color scheme
		scheme = 'auto-diverging';
		// also adjust extents to 0 => halfway
		let max = Math.max(Math.abs(ex[0]), ex[1]);
		console.warn('override extent from (%O, %O) to (%O, %O)', ex[0], ex[1], -max, max);
		self.$extent = [-max, max];
		// we also need to make sure ncolors is odd so 0 is inbetween the colors
		if ( ncolors % 2 == 0 ) { ncolors++; if ( ncolors > 11 ) ncolors = 11; }
	    } else scheme = 'auto-sequential'; // can we do better than this?
	}
	if ( /^auto\-/.test(scheme) ) {
	    var m = scheme.match(/^auto\-(.*)$/);
	    let scarr = colorbrewer.scheme[m[1]];
	    if ( scarr ) {
		scheme = scarr[Math.floor(Math.random()*scarr.length)] // pick one at random
		ip = colorbrewer[scheme];
		if ( ! ip[ncolors] ) {
		    let found = false;
		    scarr.forEach(function(name) {
			if ( found ) return;
			else {
			    ip = colorbrewer[name];
			    if ( ip[ncolors] ) {
				found = true;
				scheme = name;
			    }
			}
		    });
		    if ( ! found ) {
			scheme = scarr[Math.floor(Math.random()*scarr.length)] // pick one at random
			ip = colorbrewer[scheme];
			ncolors = _.last(_.keys(ip));
		    }
		}
		console.warn('final scheme: %O, ncolors = %O', scheme, ncolors);
	    } else scheme = 'OrRd'; // a general default
	}
	ip = colorbrewer[scheme];
	if ( ! ip[ncolors] ) {
	    let override = _.last(_.keys(ip));
	    ncolors = override;
	}
	var f = d3.scaleQuantize().domain([0, 1]).range(ip[ncolors]);
	cfn = d3.scaleSequential(f).domain(legend.sizeRange);
    }
    if ( self.$dataset ) {
	var update = {}
	_.keys(self.$dataset).forEach(function(key) {
	    var color = cfn(legend.scaleFn(self.$dataset[key].value));
	    self.$dataset[key].fillColor = color;
	    update[key] = color;
	});
	self.$chart.updateChoropleth(self.$dataset);
    }
    return cfn;
}

function suggestScale(stats, extArr)
{
    console.log('suggestScale(): min = %O, stdev = %O, histo = %O, extArr = %O, %O',
		stats.min, stats.stdev, stats.histo, extArr[0], extArr[1]);
    if ( extArr[0] < 0 || extArr[1] < 0 ) return 'linear'
    if ( stats.min < 0 ) return 'linear';
    if ( stats.stdev < 1000 ) return 'linear';
    {
	let min = stats.min;
	if ( min == 0 ) {
	    min = 1;
	    while ( min > 0.0001 * extArr[1] ) min *= 0.1
	}
	extArr[0] = min;
	return 'log'
    }
}

function getStats(values)
{
    return {
	min: d3.min(values),
	stdev: d3.deviation(values),
	histo: d3.histogram()(values)
    }
}

LiteDatamap.prototype.setupLegend = function(stats)
{
    var self = this;
    var chartNode = $(self.$chartEl).find('.legend').get(0);
    d3.select(chartNode).select('svg.scale').remove();
    if ( ! _.get(self.$options, 'legend.show', true) ) return;
    var pos = _.get(self.$options, 'legend.position', 'top');
    var svgWidth, svgHeight;
    if ( pos == 'top' || pos == 'bottom' ) {
	svgWidth = _.get(self.$options, 'legend.length', '100%');
	svgHeight = _.get(self.$options, 'legend.breadth', 50);
    }
    var svg = d3.select(chartNode).append('svg')
	.attr('class', 'scale')
	.style('width', svgWidth)
	.style('height', svgHeight);
    var hpadding = _.get(self.$options, 'legend.horizPadding', 10);
    var realWidth = svg.node().getBoundingClientRect().width - 2*hpadding;
    var scale, axis;
    var type = _.get(self.$options, 'legend.type', 'linear'), ticks;
    if ( type == 'auto' || type == 'log' ) type = suggestScale(stats, self.$extent);
    if ( type == 'linear' ) {
	scale = d3.scaleLinear().range([0, realWidth]).domain(self.$extent).nice();
	ticks = scale.ticks(_.get(self.$options, 'series.colorMap.numColors', 5))
	var fv = d3.format('.2s'); self.$fmt = function(v) { return fv(v).replace('G', 'B'); };
	axis = pos == 'top' ? d3.axisTop(scale) : d3.axisBottom(scale);
	axis.tickFormat(self.$fmt);
    } else {
	scale = d3.scaleLog().range([0, realWidth]).domain(self.$extent);
	ticks = [];
	for (let x = self.$extent[0] ; x <= self.$extent[1] ; x *= 10) ticks.push(+x);
	axis = pos == 'top' ? d3.axisTop(scale) : d3.axisBottom(scale);
	let nticks = Math.floor(self.$extent[0] > 1 ? Math.log10(self.$extent[1]) - Math.log10(self.$extent[0])
				: Math.log10(self.$extent[1]));
	console.log('nticks = %O, realWidth = %O', nticks, realWidth);
	axis.ticks(nticks); self.$fmt = d3.format('.1s');
	var fv = d3.format('.1s'); self.$fmt = function(v) { return fv(v).replace('G', 'B'); };
	axis.tickFormat(self.$fmt);
    }
    return {
	type: type,
	sizeRange: [0, realWidth],
	scaleFn: scale,
	drawAxis: function(cfn) {
	    svg.append('g').attr('transform', 'translate('+hpadding+', 20)').call(axis);
	    svg.append('g')
		.attr('transform', 'translate('+hpadding+', 30)')
		.selectAll('circle')
		.data(ticks)
		.enter()
		.append('circle')
		.attr('r', 5)
		.attr('cy', 5)
		.attr('cx', function(d) { return scale(d) })
		.style('fill', function(d) {
		    return cfn(scale(d))
		});
	},
    };
}

LiteDatamap.prototype.setupPopup = function()
{
    let self = this;
    let debug = _.get(self.$options, 'tooltip.debug', false);
    let fmt = _.get(self.$options, 'tooltip.debugFormat');
    let excl = _.get(self.$options, 'tooltip.excludeFields', '');
    let exclFields = excl.split(',').map(x => x.trim());
    // add value field to exclude since it must be formatted.
    let cn = self.$aggs.request.colNames[0];
    exclFields.push(cn);
    let fn = ejs.compile(_.get(self.$options, 'tooltip.formatStr'));
    self.$popupTmpl = function(args) {
	args.options = { exclude: exclFields };
	if ( args.data && args.data.item && cn in args.data.item ) {
	    $.extend(true, args.options, {
		value: args.data.item[cn],
		valuePc: format_num(args.data.item[cn]*100.0/(self.$extent[1]-self.$extent[0]), 2),
		min: self.$extent[0],
		max: self.$extent[1]
	    });
	    if ( self.$fmt ) args.options.valueFmt = self.$fmt(args.data.item[cn]);
	}
	if ( debug ) {
	    if ( fmt ) console.log(sprintf(fmt, args));
	    else console.log('popup(): args = %O', args);
	}
	return fn(args);
    };
}

LiteDatamap.prototype.getGeoConfig = function()
{
    var self = this;
    return {
	borderWidth: _.get(self.$options, 'series.border.borderWidth'),
	borderColor: _.get(self.$options, 'series.border.borderColor'),
	borderOpacity: _.get(self.$options, 'series.border.borderOpacity'),
	popupTemplate: function(geo, data) {
	    try {
		return (self.$popupTmpl ? self.$popupTmpl({geo:geo,data:data}) : geo.properties.name);
	    } catch(err) {
		console.warn(err);
		return geo.properties.name;
	    }
	},
	popupOnHover: _.get(self.$options, 'tooltip.show'),
	highlightOnHover: _.get(self.$options, 'series.highlight.enabled'),
	highlightFillColor: _.get(self.$options, 'series.highlight.fillColor'),
	highlightFillOpacity: _.get(self.$options, 'series.highlight.fillOpacity'),
        highlightBorderColor: _.get(self.$options, 'series.highlight.borderColor'),
        highlightBorderWidth: _.get(self.$options, 'series.highlight.borderWidth'),
        highlightBorderOpacity: _.get(self.$options, 'series.highlight.borderOpacity'),
    };
}

LiteDatamap.prototype.applyOptions = function(options)
{
    var self = this;
    self.setupTitle();
    var legend = self.setupLegend(getStats(_.values(self.$dataset).map(x => +x.value)));
    console.log('legend = %O', legend);
    var colorFn = self.setupColors(legend);
    legend.drawAxis(colorFn);
    var rn = self.$aggs.request.rowNames, cn = self.$aggs.request.colNames[0];
    if ( rn.length == 2 ) {
	self.$slider.setAnimator(function() {
	    var cur = self.$slider.value();
	    var dataset = {};
	    self.$arr
		.filter(x => x[rn[1]] == cur)
		.forEach(x => dataset[x[rn[0]]] = {
		    item: x,
		    fillColor: colorFn(legend.scaleFn(x[cn])),
		    value: x[cn]
		});
	    self.$chart.updateChoropleth(self.$dataset = dataset);
	});
    }
    self.setupPopup();
    if ( self.$chart ) {
	var gc = self.getGeoConfig();
	/* stroke settings are set directly on the paths since there is no re-drawing. */
	var path = self.$chart.svg.select('g.datamaps-subunits').selectAll('path');
	path.style('stroke', gc.borderColor)
	    .style('stroke-width', gc.borderWidth)
	    .style('stroke-opacity', gc.borderOpacity);
	/* highlight settings can b set on the chart's options. */
        ['highlightOnHover', 'highlightFillColor', 'highlightBorderColor',
	 'highlightBorderWidth', 'highlightBorderOpacity', 'highlightFillOpacity'].forEach(function(name) {
	     self.$chart.options.geographyConfig[name] = gc[name];
	 });
    }
}

LiteDatamap.prototype.renderChart = function()
{
    var self = this;

    var aggs = self.$aggs;
    if ( self.$opts ) self.$opts.destroy();
    self.clearElement();
    self.setupChartElement(aggs.request.rowNames.length == 2);
    var opts = new LiteDatamapOpts(self.$chartEl); self.$opts = opts; self.updateSpecs(opts);
    var options = {};
    $.extend(true, opts.getValue(), options);
    $.extend(true, opts.getValue(), self.$options);
    opts.build();
    self.$options = opts.convert(opts.getValue());
    console.log('options = %O', self.$options);

    var rn = self.$aggs.request.rowNames, cn = self.$aggs.request.colNames[0];
    var arr = d3.csvParse(self.$aggs.responseCSV); self.$arr = arr;
    console.log('responseCSV = %O', arr);
    var valarr = arr.map(x => +x[cn]).sort((a, b) => a - b);
    console.log('valarr = %O, %O', valarr[0], valarr[valarr.length - 1]);
    var ext = d3.extent(arr.map(x => +x[cn]));
    console.log('ext = %O, %O', ext[0], ext[1]);
    _.set(self.$options, 'legend.minValue', ext[0]);
    _.set(self.$options, 'legend.maxValue', ext[1]);
    self.$extent = ext;
    opts.syncDisplay();
    self.setupTitle();
    var legend = self.setupLegend(getStats(arr.map(x => +x[cn])));
    var colorFn = self.setupColors(legend);
    legend.drawAxis(colorFn);
    self.setupPopup();
    self.$dataset = {};
    if ( rn.length == 2 ) {
	self.$slider = new MySlider($(self.$chartEl).find('.playbtn > button').get(0),
				    $(self.$chartEl).find('.slider > svg').get(0),
				    _.uniq(arr.map(x => x[rn[1]])));
	var cur = self.$slider.value();
	arr
	    .filter(x => x[rn[1]] == cur)
	    .forEach(x => self.$dataset[x[rn[0]]] = {
		item: x,
		fillColor: colorFn(legend.scaleFn(x[cn])),
		value: x[cn]
	    });
    } else {
	arr
	    .forEach(x => self.$dataset[x[rn[0]]] = {
		item: x,
		fillColor: colorFn(legend.scaleFn(x[cn])),
		value: x[cn]
	    });
    }
    self.$chart = new Datamap({
	element: $(self.$chartEl).find('.chart').get(0),
	scope: self.$scope,
	projection: 'mercator',
	fills: { defaultFill: _.get(self.$options, 'series.map.defaultColor', '#FFF') },
	data: self.$dataset,
	geographyConfig: self.getGeoConfig()
    });
    console.log('$chart = %O', self.$chart);
    if ( rn.length == 2 ) {
	self.$slider.setAnimator(function() {
	    var cur = self.$slider.value();
	    var dataset = {};
	    arr
		.filter(x => x[rn[1]] == cur)
		.forEach(x => dataset[x[rn[0]]] = {
		    item: x,
		    fillColor: colorFn(legend.scaleFn(x[cn])),
		    value: x[cn]
		});
	    self.$chart.updateChoropleth(self.$dataset = dataset);
	});
    }
}

/*
 * Save settings so we can reload into an instance of LiteDatamap.
 */
LiteDatamap.prototype.saveForExport = function()
{
    var self = this;
    return JSON.stringify({
	aggs: self.$aggs,
	init: { type: 'datamap' },
	options: JSON.parse(JSON.stringify(self.$options)),
    });
}

/*
 * Save settings so we can directly load into Datamaps. Does not save all settings:
 * specifically, title/subtitle, player and legend, since these are not part of
 * Datamaps.
 */
LiteDatamap.prototype.liveExport = function()
{
    var self = this;
    var options = JSON.parse(JSON.stringify(self.$chart.options));
    ['element', 'setProjection', 'done'].forEach(function(name) { delete options[name]; });
    return JSON.stringify({
	aggs: self.$aggs,
	init: { type: 'datamap' },
	options: options,
    });
    return JSON.stringify(this.amendOptions(this.$options));
}

exports.LiteDatamap = LiteDatamap;
